import { useCallback, useEffect, useState } from 'react';

import { client, useErrorNotifications, useFormErrorHandler } from 'core/http';
import { UserSchema } from 'core/schemas/user';
import { User } from 'core/types/user';

export default function useUser(id: string) {
  const handleFormErrors = useFormErrorHandler();
  const showErrorNotification = useErrorNotifications();
  const [user, setUser] = useState<User>();

  useEffect(() => {
    client()
      .get<User>(`users/${id}`)
      .then(response => response.data)
      .then(setUser)
      .catch(showErrorNotification);
  }, [id, showErrorNotification]);

  const update = useCallback(
    (payload: UserSchema) => {
      return client()
        .patch<User>(`users/${id}`, payload)
        .then(response => response.data)
        .then(setUser)
        .catch(handleFormErrors);
    },
    [handleFormErrors, id]
  );

  return { user, update };
}
